import { Action } from '@ngrx/store';

export enum EPartnerSubscriptionActions {
  PartnerSubscriptionSuccess = '[PARTNER_SUBSCRIPTION] Partner subscription success'
}

export class PartnerSubscriptionSuccess implements Action {
  public readonly type = EPartnerSubscriptionActions.PartnerSubscriptionSuccess;
}

export type PartnerSubscriptionActions = PartnerSubscriptionSuccess;
